export const accountTypeENUM = {
  DUI_GONG: 1,
  ALIPAY: 2,
  SUB_ACCOUNT: 6,
}
